import { useState, useEffect } from 'react';
import maintenanceService, { MaintenanceStatus } from '../services/maintenance.service';

export const useMaintenanceStatus = (pollingInterval: number = 30000) => {
  const [status, setStatus] = useState<MaintenanceStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial check
    const checkInitialStatus = async () => {
      setLoading(true);
      try {
        const currentStatus = await maintenanceService.checkStatus();
        setStatus(currentStatus);
      } finally {
        setLoading(false);
      }
    };
    
    checkInitialStatus();

    // Start polling
    maintenanceService.startPolling(pollingInterval);

    // Subscribe to status changes
    const unsubscribe = maintenanceService.onStatusChange((newStatus) => {
      setStatus(newStatus);
    });

    // Cleanup
    return () => {
      unsubscribe();
      // Note: We don't stop polling here as other components might need it
    };
  }, [pollingInterval]);

  return {
    status,
    loading,
    isOperational: status ? !status.maintenance.active : true,
    isReadOnly: status?.maintenance.mode === 'READ_ONLY',
    isSurveyOnly: status?.maintenance.mode === 'SURVEY_ONLY',
    isFullMaintenance: status?.maintenance.mode === 'FULL',
  };
};